// extracted by mini-css-extract-plugin
export default {"card":"h0-z","carouselContainer":"i0-z","carouselContent":"j0-z"};